import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() labelLinkArray: any = []
  constructor(
      private route: ActivatedRoute,
      private router: Router,
  ) { }

  ngOnInit() {
  }

  navigate(event, link, index) {
      if (link == [] || link == null || link == "") {
          event.preventDefault();
          event.stopPropagation();
      }
      else {
          this.router.navigate(link);
      }
  }

}
